// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__IMlXn","description":"MealItem_description__3Ff9C","price":"MealItem_price__2ct5w"};